export default "__VITE_ASSET__D737iCL0__"